import React, { useEffect, useState } from "react";
import Footer from "../../components/footer/footer";
import Navbar from "../../components/navbar/Navbar";
import "./dwechome.css";
import InterestedSectionMain from "../../components/interested section/InterestedSectionMain";

import "./couselllingeducationloan.css";
const wave_img = require("../../assets/wave_counellling_read_more.svg");
const vector_img = require("../../assets/counselling_hero_section_img.svg");

function CounsellingMainPage(props) {
  return (
    <>
      <div className="nav_container">
        <Navbar fromPage="cousellingmainpage" />
      </div>
      <div className="main_container_couselling_page_section">
        <div className="main_heading_contianer">
          <div className="top_couselling_container">
            <div className="flx_container_text_extra_text_contianer">
              <p className="top_couselling_text">COUNSELLING</p>
              <p className="top_couselling_extra_text">
                Virtual counseling sessions for study abroad: At, DWEC, we
                assist you in your study abroad journey by reaching out to you
                in person. Stay in your comfort zone and let us guide you with
                brilliant career opportunities ahead.
              </p>
            </div>
            <div className="top_couselling_imgSec_container">
              <div className="top_couselling_img_container">
                <img src={vector_img.default} alt="img" />
              </div>
            </div>
          </div>
        </div>
        <div className="wave_img_contianer">
          <img src={wave_img.default} alt="img" />
        </div>

        <section className="education gbg pb20" id="edu">
          <div className="left">
            <h2>Counselling</h2>

            <h3>
            Counseling is the first step of your study abroad dream.<br /> 
            Getting counseling is what makes you embark on a new journey.
            </h3>

            <p>
              <strong>
                Are you perplexed regarding your study abroad dream?
              </strong>{" "}
              Then worry not, we, here at Dynamic World Education Community
              offer personalized counseling services. And the best part about it
              is we take no charge for consulting us. Counseling is an important
              part of the study abroad journey. Students need to know the best
              course and institution for them. We counsel students by knowing
              about their interests and aptitude and suggesting to them the best
              course and university that suits them.
            </p>

            <p>
              Our organization sticks to its name and provides you with the best
              most affordable counseling services. At DWEC, we assist you with:
            </p>

            <ul>
              <li>Unbiased and expert counseling via personal interview</li>

              <li>Assistance in application submission</li>

              <li>Registration and preparation guidance for IELTS</li>

              <li>Guidance on offer letters</li>

              <li>Assistance with health insurance and accommodation</li>

              <li>Welcome events in the study country</li>

              <li>Shortlisting  of potential schools and universities</li>

              <li>Guidance in Writing a Statement of Purpose (SOP)</li>

              <li>Guidance on available scholarships and how to apply</li>

              <li>Assistance in visa application</li>

              <li>Regular follow-up and support in person, call and e- mail</li>

              <li>Pre-departure briefing once you've received your visa</li>
            </ul>
          </div>
        </section>

        <section className="education gbg padding0">
          <div className="">
            <div className="left width00">
              <p>
                We understand each and every student and work on them
                individually. In addition, we also provide online educational
                webinars and fairs with International partners. We guide
                students in the right direction for their Careers and our
                guidance is purely unbiased. Here are a few benefits of
                counseling:
              </p>

              <ul>
                <li>
                  You will get to know about possible career opportunities
                </li>

                <li>
                  You will be provided with the future job prospectus
                  information of the course chosen.
                </li>

                <li>
                  You will understand the international scenario of the chosen
                  field.
                </li>

                <li>
                  You will Get a free profile evaluation done for possible
                  scholarships.
                </li>
              </ul>

              <p>
                We have excellent counselors who have great expertise in the
                field. Our counselors work with each and every student and provide
                them with the most suitable opportunities in the international arena.
                They have tie-ups with agents who are directly in touch with the
                foreign universities and colleges.
              </p>

              <p>
                <strong>Roles and responsibilities that we fulfill:</strong>
              </p>

              <ul>
                <li>
                  We maintain the database of every student and the status of
                  their Visa process.
                </li>

                <li>
                  Our counselors support a student's academic needs along with
                  their social and emotional needs.
                </li>

                <li>
                  We, here at DWEC take care of the complete visa process. We
                  collect visa applications from the respective embassies.
                </li>

                <li>
                  From getting the form filled to verification of documents, we
                  guide students during the entire process.
                </li>

                <li>
                  We listen to students' queries and give them suitable
                  guidance.
                </li>
              </ul>
            </div>

            <div className="clear"></div>
          </div>
        </section>
      </div>
      <InterestedSectionMain />
      <Footer />
    </>
  );
}

export default CounsellingMainPage;
